module.exports = __webpack_public_path__ + "static/img/empty.e706dd15.svg";